<template>
  <div>
    <transition name="sidebar">
      <!-- 收起状态的独立侧边栏 -->
      <div
          v-if="isSideCollapsed"
          class="side-menu-collapsed"
      >
        <div class="collapsed-header" @click="$emit('agentOpen')">
          <div class="toggle-side">
            <img src="@/assets/images/logo.png"/>
          </div>
        </div>
        <div
            class="toggle-side collapsed-new-chat"
            @click="$emit('toggle')"
        >
          <SvgIcon
              :size="28"
              color="rgb(139 139 139)"
              name="toggle-right"
          />
        </div>
        <div
            class="collapsed-new-chat"
            @click="$emit('new-chat')"
        >
          <SvgIcon
              :size="28"
              color="rgb(139 139 139)"
              name="plus"
          />
        </div>
      </div>
      <!-- 展开状态的侧边栏 -->
      <div
          v-if="!isSideCollapsed"
          class="side-menu"
      >
        <div class="side-header">
          <div class="side-action">
            <div class="action-logo" @click="$emit('agentOpen')">
              <img src="@/assets/images/logo.png">
              <span>数字枢纽</span>
            </div>
            <div
                class="toggle-side"
                @click="$emit('toggle')"
            >
              <SvgIcon
                  :size="28"
                  color="rgb(139 139 139)"
                  name="toggle-left"
              />
            </div>
          </div>
          <div
              class="new-chat"
              @click="$emit('new-chat')"
          >
            <div style="margin-right: 10px"><i class="el-icon-plus"></i></div>
            新对话
            <!--          <span class="keyboard-shortcut">Ctrl+K</span>-->
          </div>
        </div>
        <!--        <div class="history-box">-->
        <!--          <img src="@/assets/images/home1.png"/>-->
        <!--          <span>历史会话</span>-->
        <!--        </div>-->
        <el-x-conversations
            v-if="conversationList.length"
            v-loading="isLoadingConversations"
            :active="activeConversation"
            :groupable="true"
            :items="conversationList"
            :label-max-width="190"
            :styleConfig="{ width: '260px', backgroundColor: '#ECF5FF', padding: 0 }"
            class="conversation-list"
            @change="$emit('conversation-change', $event)"
        >
          <!-- 分组标题：左侧标题 + 数量，右侧展开/收起箭头 -->
          <template #group-title="{ group }">
            <div
                :class="{ 'is-collapsed': isGroupCollapsed(group) }"
                class="group-title-row"
                @click="toggleGroup(group, $event)"
            >
              <span class="group-title-text">{{ group.title }}</span>
              <i
                  :class="{ 'is-collapsed': isGroupCollapsed(group) }"
                  class="el-icon-arrow-down group-title-arrow"
              ></i>
            </div>
          </template>
          <!-- 会话项：标题 + 三个点下拉菜单（重命名/分享/删除） -->
          <template #label="{ item }">
            <div :class="['conversation-item-row', { 'menu-open': menuOpenId === item.id }]">
              <span class="item-label">{{ item.label }}</span>
              <el-dropdown
                  placement="bottom-end"
                  trigger="click"
                  @command="handleItemMenuCommand(item, $event)"
                  @click.native.stop
                  @visible-change="visible => handleMenuVisibleChange(item, visible)"
              >
                <i
                    :data-more-id="item.id"
                    class="el-icon-more item-more-btn"
                    title="更多操作"
                ></i>
                <el-dropdown-menu slot="dropdown" class="item-more-menu">
                  <el-dropdown-item command="rename" icon="el-icon-edit">重命名</el-dropdown-item>
                  <el-dropdown-item command="share" icon="el-icon-share">分享</el-dropdown-item>
                  <el-dropdown-item class="item-more-delete" command="delete" icon="el-icon-delete">删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-x-conversations>
        <el-empty
            v-else
            description="请开始今天的聊天吧"
        ></el-empty>
        <div class="logout-box">
          <el-popover
              v-model="userMenuVisible"
              placement="top-end"
              popper-class="popper-logout"
          >
            <div class="user-flex" @click="userClick('set')">
              <img class="el-setting" src="@/assets/images/home4.png"></img>
              <span>个人设置</span>
            </div>
            <div class="user-flex" @click="userClick('logout')">
              <img class="el-setting" src="@/assets/images/home3.png"></img>
              <span>退出登录</span>
            </div>
            <div slot="reference" class="user-info">
              <div class="logout-img">
                <img v-if="profile_info.avatar_url" :src="profile_info.avatar_url" class="img-class"/>
                <img v-else class="img-class" src="@/assets/images/avatar.png"/>
                <div class="ellipsis">{{ profile_info.nickname }}</div>
              </div>
              <img src="@/assets/images/home5.png"
                   style="width: 16px;height: 16px;display: flex;flex-shrink: 0;"/>
            </div>
          </el-popover>
        </div>
      </div>
    </transition>
    <Settings
        v-if="settingsVisible"
        :settingsVisible.sync="settingsVisible"
        @settingsSave="settingsSave"
    />
  </div>
</template>

<script>
import {logout} from "@/api/login";
import {removeToken} from "@/utils/auth";
import Settings from "@/components/Settings.vue";
import RoleSettings from "@/components/RoleSettings.vue"
import {toggle_collapse} from "@/api/chat";

export default {
  name: 'Sidebar',
  props: {
    isSideCollapsed: {
      type: Boolean,
      default: false,
    },

    conversationList: {
      type: Array,
      default: () => [],
    },
    collapsed_ids: {
      type: Array,
      default: () => [],
    },
    activeConversation: {
      type: String,
      default: null,
    },
    isLoadingConversations: {
      type: Boolean,
      default: false,
    },
    profile_info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    Settings,
    RoleSettings
  },
  data() {
    return {
      settingsVisible: false,
      userMenuVisible: false,
      // 本次点击切换过的 robot_id -> 是否收起（默认收起状态以父级传入的 collapsed_ids 为准）
      localToggle: {},
      // 当前打开下拉菜单的会话 id（null 表示没有菜单打开）
      menuOpenId: null,
    }
  },
  methods: {
    settingsSave() {
      this.$emit("settingsSaveClick");
    },
    userClick(type) {
      if (type === 'logout') {
        logout().then(() => {
          removeToken()
          this.$router.replace('/')
        }).catch(() => {
        })
      } else {
        this.settingsVisible = true
        this.userMenuVisible = false
      }
    },
    // 判断分组是否收起：默认按父级传入的 collapsed_ids 判断，本次点击切换过的以本地记录为准
    isGroupCollapsed(group) {
      const info = this.getGroupRobotId(group);
      if (!info || info.robot_id == null) return false;
      const rid = String(info.robot_id);
      const base = (this.collapsed_ids || []).some(id => String(id) === rid);
      return this.localToggle[rid] !== undefined ? this.localToggle[rid] : base;
    },
    // 解析分组对应的机器人信息：优先取会话自带的字段
    getGroupRobotId(group) {
      if (!group) return null;
      const item = group.children && group.children[0];
      if (item && item.robot_id != null) return {
        robot_id: item.robot_id,
        name: group.key || group.title,
        is_collapsed: item.is_collapsed,
      }
    },
    // 切换分组的展开/收起：本地状态即时生效 + 调接口保存
    // 同时用 max-height 过渡做平滑折叠动画（display:none / grid 轨道动画均有闪烁问题）
    toggleGroup(group, event) {
      const info = this.getGroupRobotId(group);
      if (!info || info.robot_id == null) return; // 拿不到 robot_id（如临时会话），忽略
      const collapsed = !this.isGroupCollapsed(group);
      // 提前取出 DOM，避免异步回调中 currentTarget 已失效
      const titleRow = event && event.currentTarget;
      this.$set(this.localToggle, String(info.robot_id), collapsed);
      this.animateGroupCollapse(titleRow, collapsed);
      toggle_collapse({
        robot_id: info.robot_id,
        is_collapsed: collapsed,
      }).catch(() => {
        // 接口失败时回滚本地状态
        this.$set(this.localToggle, String(info.robot_id), !collapsed);
        this.animateGroupCollapse(titleRow, !collapsed);
        this.$message.error('保存分组状态失败');
      });
    },
    // 根据分组标题行定位会话列表 DOM，用 max-height 精确高度做折叠/展开动画
    // 先锁定当前真实高度再过渡到目标高度，保证动画节奏与内容高度一致、不瞬跳
    animateGroupCollapse(titleRow, collapsed) {
      const itemsEl = titleRow && titleRow.parentElement && titleRow.parentElement.parentElement
          && titleRow.parentElement.parentElement.querySelector('.el-x-conversation-group-items');
      if (!itemsEl) return;
      if (itemsEl._collapseTimer) clearTimeout(itemsEl._collapseTimer);
      const clearMaxHeight = () => {
        itemsEl.style.maxHeight = '';
        itemsEl.removeEventListener('transitionend', clearMaxHeight);
        itemsEl._collapseTimer = null;
      };
      // 锁定额外高度 → 强制回流 → 过渡到目标高度
      itemsEl.style.maxHeight = collapsed ? itemsEl.scrollHeight + 'px' : '0px';
      itemsEl.getBoundingClientRect();
      itemsEl.style.maxHeight = collapsed ? '0px' : itemsEl.scrollHeight + 'px';
      // 动画结束后清除内联高度恢复自适应；transitionend 未触发时定时兜底
      itemsEl.addEventListener('transitionend', clearMaxHeight);
      itemsEl._collapseTimer = setTimeout(clearMaxHeight, 400);
    },
    // 三个点下拉菜单命令：重命名/分享/删除，统一走 menu-command 由父级处理
    handleItemMenuCommand(item, command) {
      this.$emit('menu-command', command, item);
    },
    // 菜单打开/关闭时记录打开的会话项：
    // 打开期间鼠标移到弹层上会脱离 li 的 :hover，靠 menu-open 状态保持选中高亮和三个点不消失。
    // 注意：状态必须是 Vue 响应式数据而非手动操作 li 的 class——
    // Vue 重渲染时会整体重写 li 的 className，手动加的类会被抹掉
    handleMenuVisibleChange(item, visible) {
      this.menuOpenId = visible ? item.id : null;
    },
  }
};
</script>

<style lang="scss" scoped>
$--color-primary: #409eff;
$--color-primary-light-9: #ecf5ff;
$--color-text-primary: #303133;
$--color-text-regular: #606266;
$--border-color-lighter: #ebeef5;

.sidebar-enter-active,
.sidebar-leave-active {
  transition: all 0.3s ease;
}

.sidebar-enter,
.sidebar-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

// 为新对话按钮添加专门的动画
.sidebar-enter-active .new-chat,
.sidebar-leave-active .new-chat {
  transition: all 0.3s ease 0.1s;
}

.sidebar-enter .new-chat,
.sidebar-leave-to .new-chat {
  opacity: 0;
  transform: translateY(-10px);
}

// 为键盘快捷键添加动画
.sidebar-enter-active .keyboard-shortcut,
.sidebar-leave-active .keyboard-shortcut {
  transition: all 0.3s ease 0.15s;
}

.sidebar-enter .keyboard-shortcut,
.sidebar-leave-to .keyboard-shortcut {
  opacity: 0;
  transform: scale(0.8);
}

.side-menu-collapsed {
  width: 68px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ECF5FF;
  border-right: 1px solid $--border-color-lighter;
  transition: all 0.3s ease;

  .collapsed-header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 0;
    border-bottom: 1px solid $--border-color-lighter;

    img {
      width: 32px;
      height: 32px;
      display: flex;
    }
  }

  .collapsed-new-chat {
    width: fit-content;
    height: fit-content;
    margin: 16px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      //background-color: #529bec;
      //border-color: $--color-primary;
    }

    i {
      font-size: 16px;
      color: $--color-text-regular;
    }
  }
}

.side-menu {
  width: 260px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ECF5FF;
  border-right: 1px solid #EAEAEA;
  transition: all 0.3s ease;
  position: relative;

  .side-header {
    flex-shrink: 0;
    padding: 16px;
    text-align: center;

    .side-action {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      .action-logo {
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          width: 32px;
          height: 32px;
          display: flex;
        }

        span {
          font-weight: 500;
          font-size: 20px;
          color: #333333;
          line-height: 28px;
          margin-left: 12px;
          display: inline-block;
          min-width: 100px;
        }
      }

    }

    .new-chat {
      --local-button: #dbeafe;
      --local-button-text: #FFFFFF;
      --local-button-hover: #c6dcf8;
      color: #FFFFFF;
      background-color: #4D79FF;
      cursor: pointer;
      height: 44px;
      border-radius: 14px;
      flex-shrink: 0;
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      padding: 0 10px;
      white-space: nowrap;
      opacity: 1;
      transition: opacity 0.3s ease, width 0.3s ease, padding 0.3s ease;

      .keyboard-shortcut {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-left: 8px;
        padding: 0 6px;
        height: 20px;
        font-size: 12px;
        color: #909399;
        background-color: #F7F7F7;
        border-radius: 4px;
        border: 1px solid #e4e7ed;
        transition: opacity 0.3s ease;
      }

      &:hover {
        //background-color: #c6dcf8;
      }
    }

    .new-chat-btn {
      width: 100%;
    }
  }

  .conversation-list {
    flex: 1;
    overflow-y: auto;
    padding: 0 8px 68px 12px;
    opacity: 1;
    transition: opacity 0.3s ease;
  }
}

// 通用的切换按钮样式
.toggle-side {
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  i {
    font-size: 14px;
    color: $--color-text-regular;
  }
}

// 移动端隐藏侧边栏
@media (max-width: 767px) {
  .side-menu,
  .side-menu-collapsed {
    display: none;
  }
}

.history-box {
  display: flex;
  align-items: center;
  color: #333333;
  line-height: 48px;

  img {
    margin-left: 6px;
    width: 24px;
    height: 24px;
    display: flex;
  }

  span {
    margin-left: 8px;
  }

}

::v-deep .el-icon-chat-dot-round {
  display: none !important;
}

::v-deep .el-x-conversation-group {
  margin-bottom: 16px;

  .el-x-conversation-item + .el-x-conversation-item {
    margin-top: 0 !important;
  }
}

::v-deep .el-x-conversation-group .el-x-conversation-group-title {
  padding: 8px;
}

// 分组标题行（图标由 #group-title 插槽渲染）
.group-title-row {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  .group-title-text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  // 箭头旋转代替图标硬切换，展开/收起过渡更顺滑
  .group-title-arrow {
    margin-right: 12px;
    font-size: 14px;
    color: #909399;
    transition: transform 0.3s ease;

    &.is-collapsed {
      transform: rotate(-90deg);
    }
  }
}

// 会话项行（#label 插槽）：标题 + 三个点下拉按钮
.conversation-item-row {
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;

  .item-label {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .item-more-btn {
    margin-left: 8px;
    font-size: 14px;
    color: #909399;
    padding: 2px;
    border-radius: 4px;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s ease, color 0.2s ease, background-color 0.2s ease;

    &:hover {
      color: #4D79FF;
      background-color: rgba(77, 121, 255, 0.1);
    }
  }
}

// 仅悬停或菜单打开时显示三个点（激活的当前会话也不常驻显示）
// menu-open 是 Vue 绑定的行内类（不受 li 重渲染影响），置于悬停规则之后保证同优先级时生效
::v-deep .el-x-conversation-item:hover .item-more-btn,
.conversation-item-row.menu-open .item-more-btn {
  opacity: 1;
}

::v-deep .el-x-conversation-item {
  color: #333333 !important;
  padding: 10px 12px !important;
  box-sizing: border-box !important;
}

// --- 会话列表 hover/active 配色（Element UI light 色阶） ---
::v-deep .el-x-conversation-item.active {
  background-color: #c6e2ff !important;
}

::v-deep .el-x-conversation-item.hovered,
::v-deep .el-x-conversation-item:hover {
  background-color: #d9ecff !important;
}

// 菜单打开期间保持选中高亮：:has() 匹配行内的 menu-open 状态
// （不依赖 li 上的类——Vue 重渲染会重写 li 的 className；项目折叠动画已使用 :has()，浏览器兼容性一致）
::v-deep .el-x-conversation-item:has(.conversation-item-row.menu-open) {
  background-color: #c6e2ff !important;
}

.logout-box {
  overflow: hidden;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  font-weight: 500;
  color: #0B132B;
  height: 60px;
  line-height: 40px;
  background: #ECF5FF !important;
  z-index: 99;
  cursor: pointer;
  border-top: 1px solid #EAEAEA;

  .user-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 12px 0 20px;
    height: 40px;

    .logout-img {
      display: flex;
      align-items: center;
      overflow: hidden;
      width: 100%;

      .img-class {
        width: 24px;
        height: 24px;
        border-radius: 12px;
        display: flex;
        flex-shrink: 0;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        margin-right: 8px;
        box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.1);
      }

      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-left: 8px;
      }
    }
  }
}

.user-flex {
  display: flex;
  align-items: center;
  height: 36px;
  line-height: 36px;
  color: #0B132B;
  cursor: pointer;

  .el-setting {
    width: 16px;
    height: 16px;
    display: flex;
    margin-right: 12px;
  }
}
</style>

<style lang="scss">
// 分组折叠动画：JS 精确测量内容高度 + max-height 过渡实现平滑收起/展开（display:none 不可动画）
// 收起状态由 :has() 保证初次渲染即生效；切换动画由 toggleGroup 用内联 max-height 驱动
.el-x-conversation-group .el-x-conversation-group-items {
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.el-x-conversation-group:has(.group-title-row.is-collapsed) .el-x-conversation-group-items {
  max-height: 0;
}

// 三个点下拉菜单（el-dropdown 弹层挂在 body 下，需全局样式）
.item-more-menu.el-dropdown-menu {
  padding: 6px;

  .el-dropdown-menu__item {
    font-size: 14px;
    line-height: 36px;
    padding: 0 16px;
  }

  // 删除项红色提示
  .item-more-delete {
    color: #F56C6C;

    &:hover,
    &:focus {
      color: #F56C6C !important;
      background-color: rgba(245, 108, 108, 0.1) !important;
    }
  }
}

.popper-logout.el-popover {
  min-width: 122px !important;
  border-radius: 12px;
  padding: 8px 0;

  .user-flex {
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: #f5f5f5;
    }
  }
}
</style>
